import { ReactElement } from 'react';

import { DECIMAL_PLACES_SHORT } from 'modules/common/const';
import { DelegateStakingRoutesConfig } from 'modules/delegateStaking/Routes';
import { useGlobalTranslation } from 'modules/i18n';
import { useGetPoolAPYs } from 'modules/pool/hooks/useGetPoolAPYs';
import { useGetTotalStaked } from 'modules/pool/hooks/useGetTotalStaked';

import { StakingSectionFooter } from '../StakingSection';
import { StakingStats, StakingStatsItem } from '../StakingStats';
import { translation } from './translation';

export function DelegateStakingEmpty(): ReactElement {
  const { keys, t } = useGlobalTranslation(translation);
  const {
    isLoading: isTotalStakedLoading,
    totalStakers,
    totalStakedAmount,
  } = useGetTotalStaked();
  const { avgAPY, isLoading: isAPYLoading } = useGetPoolAPYs();

  const isStatsLoading = isTotalStakedLoading || isAPYLoading;

  return (
    <StakingSectionFooter
      stakingLink={DelegateStakingRoutesConfig.staking.generatePath()}
    >
      <StakingStats>
        <StakingStatsItem
          isLoading={isStatsLoading}
          title={t(keys.apy)}
          value={t(keys.unit.percent, {
            value: avgAPY.decimalPlaces(DECIMAL_PLACES_SHORT).toFormat(),
          })}
        />

        <StakingStatsItem
          isLoading={isStatsLoading}
          title={t(keys.tvl)}
          value={t(keys.number.compact, {
            value: totalStakedAmount
              .decimalPlaces(DECIMAL_PLACES_SHORT)
              .toNumber(),
          })}
        />

        <StakingStatsItem
          isLoading={isStatsLoading}
          title={t(keys.stakers)}
          value={totalStakers.toFormat()}
        />
      </StakingStats>
    </StakingSectionFooter>
  );
}
